module.exports = __webpack_public_path__ + "static/media/masonry.be4501b7.png";